import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmt-info',
  templateUrl: 'rmt-info.html'
})
export class RmtInfoComponent {
  @Input() icon;
  @Input() text;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-info/rmt-info.ts